import dayjs, { Dayjs } from 'dayjs';

import { SERVER_USAGE } from '../constants';
import { UsageLevel } from '../types';

interface CountDatum {
  interval: string;
  resourceCount: number;
}

interface IntervalDataToLineProps {
  data: CountDatum[];
  numberBack: number;
  interval: 'minute' | 'hour' | 'day' | 'month';
  start: Dayjs;
  intervalCount?: number;
}

export const intervalDataToLineGraph = ({
  data,
  numberBack,
  interval,
  start,
  intervalCount = 1,
}: IntervalDataToLineProps): { interval: Date; resourceCount: number }[] => {
  const xArray = Array.from(Array(numberBack).keys())
    .reverse()
    .map((timeBack) => {
      return start
        .subtract(timeBack * intervalCount, interval)
        .utc()
        .startOf(interval);
    });

  const clonedData = [...data];

  const dataSet = xArray.map((xDate) => {
    let yResource = 0;
    let firstIndex = 0;
    while (firstIndex !== -1) {
      firstIndex = clonedData.findIndex((datum) => {
        const start = xDate;
        const end = xDate.add(intervalCount, interval);
        const isBetween = dayjs(datum.interval).isBetween(start, end, interval, '[)');

        return isBetween;
      });
      const removed = clonedData.splice(0, firstIndex + 1);

      if (removed?.[firstIndex]) {
        yResource += removed?.[firstIndex].resourceCount;
      }
    }

    return { interval: dayjs(xDate).toDate(), resourceCount: yResource };
  });

  return dataSet;
};

export const getUsageStat = (percentage?: number): UsageLevel => {
  if (!percentage) return SERVER_USAGE.low;

  if (percentage >= 0.95) return SERVER_USAGE.high;

  if (percentage >= 0.9) return SERVER_USAGE.medium;

  return SERVER_USAGE.low;
};
